import React, { useEffect, useState } from 'react';
import Button from "../components/button/Button";
import apiClient from "../common/apiClient"
import Config from "../common/Config";
import SecondaryButton from "../components/button/SecondaryButton";
import SaveAsDraft from "../components/modal/SaveAsDraft";
import ClearOrder from "../components/modal/ClearOrder";
import ClearMultiOrder from '../components/modal/ClearMultiOrder';
import FormTitle from "../components/formTitle/FormTitle";
import { ClipLoader } from "react-spinners";
import { CreateNotification } from "../components/notification/Notification";

import {
    FormGroup,
    FormLabel,
} from "@mui/material";

const MultiProductController = (props) => {
    const [formData, setFormData] = useState([]);
    const [formTypeIdsToAdd, setFormTypeIdsToAdd] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [addingProduct, setAddingProduct] = useState(false);
    const [clearOrderMessage, setClearOrderMessage] = useState("");
    const [openClearMulti, setOpenClearMulti] = useState(false);
    const [showClearMulti, setShowClearMulti] = useState(true);
    const [multiProductOrderIdToClear, setMultiProductOrderIdToClear] = useState(null);
    
    const footFormTypeId = 15
    const linerFormTypeId = 14

    const handleClearMultiBack = (id) => {
        addProduct(id);
    }
    const handleCloseClearMulti = () => {
        setOpenClearMulti(false);
        setShowClearMulti(true);
    }

    async function addProduct(id) {
        try {
            setAddingProduct(true)
            const formTypeIdsToAdd = await props.productsAdded()
            if (formTypeIdsToAdd.includes(id.toString())) {
                return null;
            }
            let addedFormTypeIDs = formTypeIdsToAdd.split(",").filter(id => id !== '')
            addedFormTypeIDs.push(id)

            await saveIds(addedFormTypeIDs);

            props.setFormTypeIdsToAdd(addedFormTypeIDs);
            await props.addFormData(addedFormTypeIDs);
        } catch (error) {
            console.log(error);
        } finally {
            setAddingProduct(false);
        }
    }

    const productsAdded = async (formTypeId) => {
        let config = {};

        config.params = {
            fieldNames: [
                "AddedFormTypeIDs"
            ],
        };

        const result = await apiClient.get(
            "fieldInputs/" + formTypeId,
            config
        )

        let currentAddedFormTypeIDs = result?.data?.find((fi) => fi.fieldName === "AddedFormTypeIDs")?.stringData ?? "";
        return currentAddedFormTypeIDs;
    }

    function productAdded(id) {
        if (!formTypeIdsToAdd) {
            return false
        }
        return formTypeIdsToAdd.includes(id.toString())
    }

    async function saveIds(addedFormTypeIDs) {
        try {
            addedFormTypeIDs = addedFormTypeIDs.filter(p => p !== "");
            const formTypeIdsToAddJson = addedFormTypeIDs.toString();

            let data = [];
            data.push({
                fieldName: "addedFormTypeIDs",
                stringData: formTypeIdsToAddJson,
            });

            const response = await apiClient.post(
                `multiProduct/${props.formTypeId}?isMulti=${true}&parentFormTypeId=${props.parentFormTypeId}`,
                data
            );

            return response.data;
        } catch (error) {
            const message = error.response?.data?.message || error.message;
            if (message.includes("order in progress")) {
                const multiOrderFormTypeIdToDelete = error.response?.data?.multiOrderParentFormTypeId || error.multiOrderParentFormTypeId;
                setMultiProductOrderIdToClear(multiOrderFormTypeIdToDelete);
                setOpenClearMulti(true);
                setClearOrderMessage(message);
            }
            throw new Error(message);
        }
    }

    function makeLoadingText() {
        return (
            <div className="loader">
                <ClipLoader color="#000000" size={40} />
            </div>
        );
    }

    useEffect(() => {
        const loadData = async () => {
            const formData = await props.getFormData()
            await setFormData(formData)

            const addedFormTypeIDs = await props.productsAdded()
            await setFormTypeIdsToAdd(addedFormTypeIDs)

            setIsLoaded(true)
        }
        loadData()
    }, [])

    if (!isLoaded) return makeLoadingText();
    return (
        <>
            <div className="checkFormWrapper filedWidth">
                <FormTitle
                    title="Add Product"
                    description=""
                />

                <form className="checkform" onSubmit={e => { e.preventDefault() }}>
                    {props.parentFormTypeId === linerFormTypeId &&
                        <div className="fieldBorder">
                            <h4 className="headLable">Products to Add</h4>
                            <div className="stepBtn">
                                <SecondaryButton
                                    text="Add Feet"
                                    onClick={() => addProduct(footFormTypeId)}
                                    disabled={productAdded(footFormTypeId) || addingProduct}
                                    glow={true}
                                />
                            </div>
                        </div>
                    }

                    {props.parentFormTypeId === footFormTypeId &&
                        <div className="fieldBorder">
                            <h4 className="headLable">Products to Add</h4>
                            <div className="stepBtn">
                                <SecondaryButton
                                    text="Add Liner"
                                    onClick={() => addProduct(linerFormTypeId)}
                                    disabled={productAdded(linerFormTypeId) || addingProduct}
                                    glow={true}
                                />
                            </div>
                        </div>
                    }
                </form>

            </div>

            <div className="handelButtons">
                <SecondaryButton
                    text="Save As Draft"
                    onClick={props.handleClickOpen}
                />
                <SecondaryButton
                    text="Clear the Order?"
                    onClick={props.handleClickClearOpen}
                />
                <div className="stepBtn">
                    <SecondaryButton
                        text="Back"
                        onClick={() => props.handleBack()}
                    />
                    <Button
                        text="Next"
                        onClick={() => props.handleNext()}
                    />
                </div>
            </div>
            <SaveAsDraft
                open={props?.open == null ? false : props?.open}
                handleClose={props.handleClose}
                showSubmit={props.showSubmit}
                setShowSubmit={props.setShowSubmit}
            />
            <ClearOrder
                openClear={props.openClear}
                handleCloseClear={props.handleCloseClear}
                showClear={props.showClear}
                setShowClear={props.setShowClear}
                formId={props.formTypeId}
                handleClearBack={props.handleClearBack}
            />
            <ClearMultiOrder
                formId={multiProductOrderIdToClear}
                openClear={openClearMulti}
                showClear={showClearMulti}
                clearOrderMessage={clearOrderMessage}
                handleCloseClear={handleCloseClearMulti}
                setShowClear={setShowClearMulti}
                handleClearBack={handleClearMultiBack}
            />
        </>
    )
}

export default MultiProductController
